/**
 * 应用展示版本（发版时请与 package.json 的 version 对齐）
 * 用于个人中心展示、审核沟通，不参与接口签名。
 */
export const APP_VERSION = '0.1.0';
